import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play-circle",
  "use": "icon-play-circle-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-play-circle\"><path d=\"M9 .75a8.25 8.25 0 10.001 16.501A8.25 8.25 0 009 .75zm0 15.1a6.852 6.852 0 010-13.7 6.852 6.852 0 010 13.7z\" /><path d=\"M12.819 8.762l-5.453-3.96a.293.293 0 00-.466.238v7.919c0 .241.273.377.466.237l5.453-3.959a.294.294 0 000-.475zM8.075 11.23V6.77L11.145 9l-3.07 2.23z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol